import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {FormattedMessage} from "react-intl";
import {setRowItems} from "../../../actions/selectionFunctions";
import {getCartItemObject} from "../../../misc/helpers";


const RowItemRelatedProductsButton = (props) => {

  const {currentFeature, rowItems, setRowItems, qtActiveCategory} = props;

  if (!Array.isArray(currentFeature.dbFeature.relatedFeatures) || !currentFeature.dbFeature.relatedFeatures.length) {
    return null
  }

  const thisFeature = rowItems.find(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);

  const handleRelatedProductsClick = () => {
    const newRowItems = [...rowItems];
    const existingItemIndex = newRowItems.findIndex(rItem => rItem.cartFeature.dbFeature.id === currentFeature.dbFeature.id);
    if (existingItemIndex > -1) {
      newRowItems[existingItemIndex].showRowRelatedItems = !newRowItems[existingItemIndex].showRowRelatedItems;
    } else {
      const cartItemObject = getCartItemObject(currentFeature, 0, qtActiveCategory);
      cartItemObject.showRowRelatedItems = true;
      newRowItems.push(cartItemObject)
    }
    setRowItems(newRowItems);
  };

  return (
    <span className={"m-triangle" + (thisFeature && thisFeature.showRowRelatedItems ? " m-triangle--active" : "")}
          onClick={handleRelatedProductsClick}>
      <FormattedMessage id="materialsPage.rowItem.relatedProducts"/>
    </span>
  )
};

RowItemRelatedProductsButton.propTypes = {
  currentFeature: PropTypes.object.isRequired,
};

const mapStateToProps = (store) => {
  const {rowItems} = store.selectionState;
  return {
    rowItems,
    qtActiveCategory: store.qtState.qtActiveCategory,
  };
};

const mapDispatchToProps = {
  setRowItems
}

export default connect(mapStateToProps, mapDispatchToProps)(RowItemRelatedProductsButton);
